import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Counter from '@spa/shared/components/Counter';
import { Container } from './styles';

const FilterCounter = ({ name, min, max, value, onChange = () => {}, labelTranslation, icon = null }) => {
  const onChangeWithIndicator = useCallback(value => onChange(name, value), [labelTranslation, onChange]);

  return (
    <Container>
      <span>
        {icon}
        <label>{labelTranslation}</label>
      </span>
      <Counter min={min} max={max} value={value} onUpdate={onChangeWithIndicator} />
    </Container>
  );
};

FilterCounter.propTypes = {
  name: PropTypes.string.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  value: PropTypes.number,
  setValue: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  labelTranslation: PropTypes.string.isRequired,
  icon: PropTypes.object
};

export default FilterCounter;
